import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core'

import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community'

import { TargetType } from '@flowx/designer/shared/api/active-policy-override.api'
import { FlxStatusComponent } from '@flowx/designer/shared/components/status/status.component'
import { TAG_SEVERITY, TagSeverity } from '@flowx/designer/shared/entities/tag-severity'

@Component({
  selector: 'flx-status-cell',
  templateUrl: './status-cell.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FlxStatusComponent],
})
export class StatusCellComponent implements ICellRendererAngularComp {
  value = signal<any>(null)
  statusSeverity = signal<TagSeverity>(TAG_SEVERITY.INFO)
  deprecated = signal(false)

  displayValue = computed(() => {
    const val = this.value()
    const deprecated = this.deprecated()
    // Handle boolean values for enabled/disabled states

    if (deprecated) {
      return 'Deprecated'
    }

    return typeof val === 'boolean' ? (val ? 'Active' : 'Deactivated') : String(val)
  })

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.value.set(params.value)
    // Get severity from data (provided by service) or from getSeverity function, or default to 'info'
    let severity = params.data?.statusSeverity || TAG_SEVERITY.INFO

    // If a getSeverity function is provided in cellRendererParams, use it
    const getSeverity = (params as any).getSeverity
    if (getSeverity && typeof getSeverity === 'function') {
      severity = getSeverity(params.value)
    }

    if (params.data?.targetType) {
      this.deprecated.set(params.data.targetType === TargetType.ROLE)
    }

    // If statusConfig and statusField are provided, look up severity from raw data
    const statusConfig = (params as any).statusConfig
    const statusField = (params as any).statusField
    if (statusConfig && statusField && params.data?.[statusField]) {
      const rawStatus = params.data[statusField]
      severity = statusConfig[rawStatus]?.severity ?? TAG_SEVERITY.INFO
    }

    this.statusSeverity.set(severity)
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.agInit(params)
    return true
  }
}
